import type { CreateEndpointDataProviderPaginatorFlow } from '../types';
import type { AnyQueryDefinition } from '../../apiSSRModule';
import { createLimitOffsetPaginator } from './createLimitOffsetPaginator';
import { LimitOffsetPaginatorConfig, LimitOffsetPaginatorParams } from './createLimitOffsetPaginator';

/**
 * Реализация базовой пагинации с помощью параметров offset и limit.
 */
export function buildCreateLimitOffsetPaginatorFlow<
    Limit extends number = number,
    Definition extends AnyQueryDefinition = AnyQueryDefinition,
>(
    config: LimitOffsetPaginatorConfig<Limit, Definition>
): CreateEndpointDataProviderPaginatorFlow<Definition, LimitOffsetPaginatorParams<NoInfer<Limit>>> {
    return function createPaginator() {
        return createLimitOffsetPaginator(config);
    };
}
